(() => {
  const instagramUrl = 'https://www.instagram.com/milky.labs';

  function updateSocialLinks() {
    document.querySelectorAll('a[href*="instagram.com/milky.labs"]').forEach((link) => {
      link.href = instagramUrl;
      link.setAttribute('aria-label', 'Instagram');
    });

    document.querySelectorAll('a[data-social-placeholder="tiktok"]').forEach((link) => {
      link.removeAttribute('href');
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('role', 'link');
      link.style.pointerEvents = 'none';
      link.style.opacity = '0.45';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateSocialLinks, { once: true });
  } else {
    updateSocialLinks();
  }
})();
